import * as Sentry from "@sentry/browser";

// Valid URLs to send errors from.
export const WHITELIST_URLS = [
	/https?:\/\/(www\.)?okcupid\.com/,
	/https?:\/\/(www\.)?includes\.okccdn\.com/,
];

// Any errors matching these patterns will be ignored.
export const IGNORE_ERRORS = [
	"fidoCallback",
	"atomicFindClose",
	"NPObject",
	"Script error",
	"__firefox__",
	"__gCrWeb",
	"viewDidAppear",
	"viewDidDisappear",
	"viewWillDisappear",
	"CustomWLAdServer",
	"getAdPos",
	"ampproject",
	"webkitExitFullScreen",
	"'supported-color-schemes'",
	"CSSStyleSheet",
	"Unexpected token 'else'",
	'Blocked a frame with origin "https://www.okcupid.com" from accessing a cross-origin frame',
	"NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node",
];

// These decide which Sentry project to send errors to.
export const DSN = {
	Desktop: "https://cc706cb497d347f98cc3f8cf146179d5@sentry.io/44006",
	Mobile: "https://40ca79dfbcf04b938854f91b64100cc3@sentry.io/43220",
	DesktopSPA: "https://cbf83f64256e4e6fa146d7cf4b4f7f7a@sentry.io/1872935",
	MobileSPA: "https://b4e9fb0952934473be2b746e063e71c6@sentry.io/1334706",
};

// Controls the % of errors we send to Sentry (to avoid hitting our quota).
export const SAMPLE_RATE = 0.01; // 1%

// Initialize Sentry.
class SentryHelper {
	static isInitialized = false;

	static initSentry({ dsn, userid, environment, release } = {}) {
		// Already initialized, early exit.
		if (SentryHelper.isInitialized) {
			return;
		}

		SentryHelper.isInitialized = true;

		// Initialize Sentry.
		Sentry.init({
			dsn,
			environment,
			release,
			whitelistUrls: WHITELIST_URLS,
			ignoreErrors: IGNORE_ERRORS,
			sampleRate: SAMPLE_RATE,
		});

		// Add userid to Sentry scope, if available.
		if (userid) {
			SentryHelper.setSentryUserId(userid);
		}
	}

	static setSentryUserId(userid) {
		if (!SentryHelper.isInitialized) {
			return;
		}

		Sentry.configureScope((scope) => {
			scope.setUser({
				id: userid,
			});
		});
	}
}

export default SentryHelper;



// WEBPACK FOOTER //
// ./src/shared/util/SentryHelper.js